import React from 'react'

function Band() {
  return (
    <section className="bg-primary-red text-white h-auto flex flex-col items-center gap-8 py-12 md:py-12 ">
      <h6 className='font-bold text-7xl text-center leading-[4.3rem]'>Simplify how your team works today.</h6>
      <button className='text-primary-red bg-white px-8 py-4 text-2xl font-bold rounded-full'>Get Started</button>
    </section>
  )
}

export default Band